import type React from "react"

export const reportAccessibility = async (
  _App: typeof React,
  _config?: Record<string, unknown>
): Promise<void> => {
  // Disabled in dev: axe-core/react logs via console.error, which Next 16's
  // dev overlay surfaces as full-screen recoverable errors. A wrapper that
  // redirects axe's errors to console.warn caused an infinite loop because
  // other tooling intercepts console.warn too. Accessibility audit is
  // deferred to the Phase 7 rebrand, where every component gets redesigned
  // and properly labeled. Re-enable here once axe + Next 16 dev overlay
  // are reconciled.
  return Promise.resolve()
}

export default reportAccessibility
